import { handleActions } from 'redux-actions';
import produce from 'immer';

import {
	clearPassengerFilters,
	setSelectedFilters,
	ClearPassengerFiltersAction,
	SetSelectedFiltersAction
} from './actions';

import { SeatMapPassengersFilters } from '../types';

const initialState: SeatMapPassengersFilters = {};

const selectedPassengersFiltersReducer = handleActions(
	{
		[setSelectedFilters.toString()]: (state, { payload }: SetSelectedFiltersAction) =>
			produce(state, draft => {
				draft[payload.passengerId] = payload.filters;
			}),
		[clearPassengerFilters.toString()]: (state, { payload }: ClearPassengerFiltersAction) =>
			produce(state, draft => {
				const { [payload.passengerId]: removed, ...rest } = draft;

				return rest;
			})
	},
	initialState
);

export default selectedPassengersFiltersReducer;
